import styled from "@emotion/styled";

export const CalculateInnerContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  flexGrow: 1,
  marginTop: "20px",
});
